import {
	ADMINGETFEEOPERATIONTYPE_SUCCESS,
	ADMINGETFEEOPERATIONTYPE_FAILED,
	RESET_ADMINGETFEEOPERATIONTYPE,
	LOADING_ADMINGETFEEOPERATIONTYPE,
	NETWORK_ERROR_ADMINGETFEEOPERATIONTYPE
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetAdminGetFeeOperationType = () => {
	return { type: RESET_ADMINGETFEEOPERATIONTYPE };
};

const adminGetFeeOperationType =
	(userData, authTokenIs) => async (dispatch) => {
		dispatch({ type: LOADING_ADMINGETFEEOPERATIONTYPE });
		await adminServices
			.post("getFeeOperationTypeList", userData, { headers: { AuthToken: authTokenIs } })
			.then((res) => {
				switch (res.data.status) {
					case "success":
						dispatch(adminGetFeeOperationTypesuccess(res.data));
						break;
					default:
						dispatch(adminGetFeeOperationTypeFailed(res.data));
						break;
				}
			})
			.catch((err) => {
				dispatch({
					type: NETWORK_ERROR_ADMINGETFEEOPERATIONTYPE,
					payload: err
				});
			});
	};
function adminGetFeeOperationTypesuccess(data) {
	return {
		type: ADMINGETFEEOPERATIONTYPE_SUCCESS,
		payload: data
	};
}
function adminGetFeeOperationTypeFailed(data) {
	return {
		type: ADMINGETFEEOPERATIONTYPE_FAILED,
		payload: data
	};
}

export { resetAdminGetFeeOperationType, adminGetFeeOperationType };
